import api from '../utils/api';

export const addDemo = (demo) => {
    return api({
        url: '/api/demo/add',
        method: 'POST',
        data: demo
    })
}